import TextFieldPrimitive from './TextFieldPrimitive';
import { PrimitiveTextProps } from './TextFieldPrimitive.interfaces';

export default TextFieldPrimitive;
export { TextFieldPrimitive, PrimitiveTextProps };
